import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxMaxLine1FontSmBold,
  TextBoxMaxLine1FontXsBold,
} from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { TextBlock } from '../../TextBlock'
import { TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockHorizontalType1 extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockHorizontalType1 = ({
  title,
  description,
  rowGap = TextBlockRowGap.INDENT_10,
  ...rest
}: ITextBlockHorizontalType1): JSX.Element => {
  return (
    <TextBlock rowGap={rowGap} {...rest}>
      <TextBoxMaxLine1FontXsBold
        title={title}
        color={Colors.TEXT_ICON_SECONDARY}
      />
      <TextBoxMaxLine1FontSmBold title={description} />
    </TextBlock>
  )
}
